export default __webpack_public_path__ + "assets/Checkmark.93f2.svg";